var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "verify-dialog",
      attrs: {
        title: _vm.$t("login.verifyCode.title"),
        visible: _vm.dialogVisible,
        width: "360px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.close,
      },
    },
    [
      _c("div", { staticClass: "verify-content" }, [
        _c("div", { staticClass: "tip" }, [
          _vm._v(
            _vm._s(
              _vm.$t("login.verifyCode.content", {
                phoneNumber: _vm.phoneNumber,
              })
            )
          ),
        ]),
        _c(
          "div",
          { staticClass: "input-wrap" },
          [
            _c("el-input", {
              staticClass: "verify-code-input",
              attrs: { type: "text", maxlength: "6" },
              model: {
                value: _vm.code,
                callback: function ($$v) {
                  _vm.code = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "code",
              },
            }),
            _vm.showSendBtn
              ? _c(
                  "div",
                  {
                    staticClass:
                      "position-right color-1fa0e8 font-size-14 cursor-pointer",
                    on: { click: _vm.handleSendCode },
                  },
                  [
                    _vm.isCounting && _vm.countdown
                      ? _c("span", { staticStyle: { cursor: "not-allowed" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("login.verifyCode.resend")) +
                              " (" +
                              _vm._s(_vm.countdown) +
                              "s)"
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("login.verifyCode.getValidate"))
                          ),
                        ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm.showErrorNMessage
          ? _c("div", { staticClass: "error-msg" }, [
              _vm._v(_vm._s(_vm.$t("login.verifyCode.errorCode"))),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass: "action-btns",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "btn", on: { click: _vm.handleCancel } },
            [_vm._v(_vm._s(_vm.$t("login.verifyCode.cancel")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn",
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.handleVerify },
            },
            [_vm._v(" " + _vm._s(_vm.$t("login.verifyCode.continue")) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }